import * as React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../hooks/userAuth";
import { ROUTES } from "../models/enums/routes";


type PublicRoutesProps = {
  isRestricted: boolean;
};


const PublicRoutes: React.FC<PublicRoutesProps> = ({ isRestricted }) => {
  const auth = useAuth();

  const restricted = isRestricted ? auth : false;
 
 return restricted ? (
    <Navigate to={ROUTES.ADMIN + ROUTES.TENANT} />
  ) : (
    <Outlet />
  );
};

export default PublicRoutes;
